export const PAYMENT_DEADLINE = Object.freeze([
  { value: 4, days: 50, mu: "days", text: "50" },
  { value: 1, days: 45, mu: "days", text: "45" },
  { value: 2, days: 30, mu: "days", text: "30" },
  { value: 3, days: 15, mu: "days", text: "15" },
]);

export const TRUCK_COATING = Object.freeze({
  PRELATA: { value: 1, text: "Prelata" },
  CAROSAT: { value: 2, text: "Carosat" },
  BOTH: { value: 3, text: "Prelata & Carosat" },
});

export const TRUCK_TRANSPORT_TYPE = Object.freeze({
  GRUPAJ: { value: 1, text: "Grupaj" },
  EXPRES: { value: 2, text: "Expres" },
});

export const TRUCK_SPECIAL_FEATURE = Object.freeze({
  LIFT: { value: 1, text: "Lift hidraulic" }, 
  ADR: { value: 2, text: "ADR" },
  FRIDGE: { value: 3, text: "Frig" },
  MEGA: { value: 4, text: "Mega" },
  TERMO: { value: 5, text: "Termo" },
  CUSTOMS: { value: 6, text: "Cu vamă" },
  PALLET_EXCHANGE: { value: 7, text: "Paleți la schimb" },
  CRANE_LOADING: { value: 8, text: "Încărcare cu macaraua" },
});

export const TRUCK_TYPE = Object.freeze({
  // 1: Light van (Sprinter), typically up to 3.5 t
  SPRINTER: { value: 1, text: "Sprinter", capacity: null, mu: "ton" },
  // 2: Light rigid truck, 7.5 t
  CAMION_7_5T: { value: 2, text: "Camion 7.5t", capacity: 7.5, mu: "ton" },
  // 3: Medium rigid truck, 12 t
  CAMION_12T: { value: 3, text: "Camion 12t", capacity: 12, mu: "ton" },
  // 4: Heavy rigid truck, 24 t
  CAMION_24T: { value: 4, text: "Camion 24t", capacity: 24, mu: "ton" },
  // 5: Tractor + semitrailer (~40 t total)
  TRAILER: { value: 5, text: "Trailer", capacity: null, mu: "ton" },
  CADDY: { value: 6, text: "Caddy", capacity: null, mu: "ton" },
  CISTERNA: { value: 7, text: "Cisternă", capacity: null, mu: "ton" },
});

export const PLATFORM_TYPE = Object.freeze({
  SEMIREMORCA: { value: 1, text: "Semiremorcă" },
  CAMION: { value: 2, text: "Camion" },
  SPRINTER: { value: 3, text: "Sprinter" },
  AUTOTREN: { value: 4, text: "Autotren" },
  CAMION_7_5T: { value: 5, text: "Camion 7.5t" },
  CADDY: { value: 6, text: "Caddy" },
  CISTERNA: { value: 7, text: "Cisternă" },
});

/** UI dropdown order (enum values unchanged). */
export const TRUCK_TYPE_DISPLAY_ORDER = [6, 1, 5, 2, 3, 4, 7];
export const PLATFORM_TYPE_DISPLAY_ORDER = [6, 3, 5, 2, 7, 1, 4];

function orderedEnumValues(enumObj, order) {
  const byValue = Object.fromEntries(
    Object.values(enumObj).map((item) => [item.value, item]),
  );
  return order.map((value) => byValue[value]).filter(Boolean);
}

export function getTruckTypesInDisplayOrder() {
  return orderedEnumValues(TRUCK_TYPE, TRUCK_TYPE_DISPLAY_ORDER);
}

export function getPlatformTypesInDisplayOrder() {
  return orderedEnumValues(PLATFORM_TYPE, PLATFORM_TYPE_DISPLAY_ORDER);
}
